import { render, staticRenderFns } from "./collectormyteam.vue?vue&type=template&id=4ccce382&"
import script from "./collectormyteam.vue?vue&type=script&lang=js&"
export * from "./collectormyteam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports